import type { Ref, SVGProps } from "react"
import { forwardRef, memo } from "react"

interface SVGRProps {
    title?: string
    titleId?: string
}
const SvgRecordStop = (
    { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
    ref: Ref<SVGSVGElement>,
) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 42 42"
        role="img"
        ref={ref}
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <circle
            cx={21}
            cy={21}
            r={20}
            fill="#C60101"
            stroke="#fff"
            strokeWidth={2}
        />
        <path fill="#fff" stroke="#fff" d="M14.5 14.5h13v13h-13z" />
    </svg>
)
const ForwardRef = forwardRef(SvgRecordStop)
const Memo = memo(ForwardRef)
export default Memo
